/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_health': {
    width: 66,
    height: 66,
    viewBox: '0 0 66 66',
    data: '<path pid="0" d="M44 8.25a2.75 2.75 0 00-2.75-2.75h-16.5A2.75 2.75 0 0022 8.25V22H8.25a2.75 2.75 0 00-2.75 2.75v16.5A2.75 2.75 0 008.25 44H22v13.75a2.75 2.75 0 002.75 2.75h16.5A2.75 2.75 0 0044 57.75V44h13.75a2.75 2.75 0 002.75-2.75v-16.5A2.75 2.75 0 0057.75 22H44V8.25z" _stroke="#7ED09E" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
